// extracted by mini-css-extract-plugin
export default {"formContent":"AgencyApprovalForm_formContent__lRbvp"};